import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import OrganisationSelect from 'view/component/form-items/organisation-select'
import buildOrganisations from 'helper/build-organisations'

const AttachmentOrgSelect = ({ organisations }) => {
  return (
    <OrganisationSelect organisations={organisations} />
  )
}

AttachmentOrgSelect.propTypes = {
  organisations: PropTypes.array
}

const mapStateToProps = ({ organisation, article }, { articleUuid }) => ({
  organisations: buildOrganisations(organisation.organisations, article.articles.results, articleUuid)
})

export default connect(mapStateToProps)(AttachmentOrgSelect)
